var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXSocial = function SvgXSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.403 3.5h2.882l-6.296 7.201 7.407 9.799h-5.8l-4.542-5.943L5.856 20.5H2.973l6.734-7.702L2.602 3.5h5.946l4.106 5.432zm-1.011 15.274h1.597L7.68 5.135H5.967z"
  })));
};
export default SvgXSocial;